export default __webpack_public_path__ + "static/media/is.556b6bc6.svg";